export enum CalendarViewMode
{
    day,
    workWeek,
    week,
    month,
    planning
}